/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerLoginLogData model module.
 * @module model/ManagerLoginLogData
 * @version 1.0
 */
class ManagerLoginLogData {
    /**
     * Constructs a new <code>ManagerLoginLogData</code>.
     * @alias module:model/ManagerLoginLogData
     */
    constructor() { 
        
        ManagerLoginLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerLoginLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerLoginLogData} obj Optional instance to populate.
     * @return {module:model/ManagerLoginLogData} The populated <code>ManagerLoginLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerLoginLogData();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('createdIp')) {
                obj['createdIp'] = ApiClient.convertToType(data['createdIp'], 'Blob');
            }
            if (data.hasOwnProperty('loginLogNo')) {
                obj['loginLogNo'] = ApiClient.convertToType(data['loginLogNo'], 'Number');
            }
            if (data.hasOwnProperty('logSort')) {
                obj['logSort'] = ApiClient.convertToType(data['logSort'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerLoginLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerLoginLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}



/**
 * @member {String} email
 */
ManagerLoginLogData.prototype['email'] = undefined;

/**
 * @member {String} name
 */
ManagerLoginLogData.prototype['name'] = undefined;

/**
 * @member {Date} createdAt
 */
ManagerLoginLogData.prototype['createdAt'] = undefined;

/**
 * @member {Blob} createdIp
 */
ManagerLoginLogData.prototype['createdIp'] = undefined;

/**
 * @member {Number} loginLogNo
 */
ManagerLoginLogData.prototype['loginLogNo'] = undefined;

/**
 * @member {Number} logSort
 */
ManagerLoginLogData.prototype['logSort'] = undefined;






export default ManagerLoginLogData;

